// src/constants/i18n.he.ts
// ============================================================================
// Hebrew exports — thin wrapper around the factory (no logic duplication)
// ============================================================================

import { he } from '@/i18n/locales/he';
import { createI18nConstants } from './i18n.factory';

const I18N = createI18nConstants(he);

// Re-export everything (same names as before)
export const {
  WORDS,
  FIRST_NAME,
  BRAND_TITLE_SHORT,
  BRAND_TITLE_HE,

  BUSINESS,

  HTML_LANG,
  HTML_LANG_FULL,
  HOME_TITLE,
  HOME_DESC,
  HOME_HERO_TITLE,
  FOOTER_TEXT,

  SECTION_TWO_TITLE,
  SECTION_TWO_DESCRIPTION,
  SECTION_TWO_ADDITIONAL_TEXT,
  SECTION_TWO_IMG_ALT,
  SECTION_TWO_HORIZONTAL_IMG_ALT,

  SECTION_THREE_TITLE,
  SECTION_THREE_FALLBACK_TEXT,
  SECTION_THREE_ALBUMS_ERROR,
  SECTION_THREE_FILES_ERROR,
  SECTION_THREE_LOADING_TEXT,
  albumDescriptions,
  albumsText,

  SECTION_FOUR_TITLE,
  SECTION_FOUR_DESCRIPTION,
  SECTION_FOUR_CONTACT_GROUP_TITLE,
  SECTION_FOUR_EVENTS_GROUP_TITLE,
  SECTION_FOUR_SERVICES_GROUP_TITLE,
  SECTION_FOUR_CONTACT_BUTTONS,
  SECTION_FOUR_EVENT_BUTTONS,
  SECTION_FOUR_SERVICE_BUTTONS,

  SECTION_FIVE_TITLE,
  SECTION_FIVE_LINKS_HEADING,

  makeMetaDescription,
  BRAND_PREFIX_RE,
  BRAND_SUFFIX_RE,
  SEO_KEYWORD_VARIANTS,
  preferredKeyword,
  makeTitle,
  preferredKeywordForService,
  secondaryKeywordForService,
  buildWhatsAppWithText,

  SECTION_THREE_DEFAULT_ALBUM_BY_SERVICE,
  EVENT_TYPE_DESCRIPTION_COPY,
  GALLERY_HEADINGS_COPY,
  buildSection4SeoCopy,
  SECTION4_GROUP_TITLES_COPY,
  SECTION5_HEADINGS_COPY,

  SECTION1_TARGET_DESCRIPTION_LINES_BASE,
  SECTION1_TARGET_DESCRIPTION_LINES_BY_SERVICE,
  buildSection1TargetSignatureLine,
  buildSection1TargetDescriptionLines,
  SECTION2_TARGET_ADDITIONAL_BY_SERVICE,
  buildSection2TargetDescription,
  SECTION2_TARGET_ADDITIONAL_SUFFIX_BY_SERVICE,
  buildSection2TargetAdditionalText,
  buildSection4BlockCopy,
  buildSection6DefaultTitle,
  buildSection6DefaultSubtitle,
  buildCityHubSection1DescriptionLines,
  buildCityHubSection1ExtraHeadings,
  buildCityHubSection3ExtraHeadings,
  buildRegionHubSection1DescriptionLines,
  buildRegionHubSection1ExtraHeadings,

  HOME_SECTION1_DESCRIPTION_LINES,
  HOME_SECTION2_DESCRIPTION_SUFFIX,
  HOME_SECTION2_ADDITIONAL_SUFFIX,
  HOME_SECTION5_SUBTITLE_DESKTOP,
  HOME_SECTION5_SUBTITLE_MOBILE,
  HOME_SECTION6_TITLE,
  HOME_SECTION6_SUBTITLE,
  translateCity,
  translateRegion,
  translateLocationLabel,
  SECTION6_REVIEWS_COUNT
} = I18N;
